import serverApi from "../utils/serverApi"

const documentVersioningService = {
  getDocument: (isLoading = false) => serverApi({ uri: 'document-versioning', method: 'GET', isLoading: isLoading }),

  getLatestDocuments: (isLoading = false) => serverApi({ uri: 'document-versioning/public/latest', method: 'GET', isLoading: isLoading }),

  markAgreeDocument: (body) => serverApi({ uri: 'document-versioning', method: 'POST', data: body, isLoading: true }),
};

export default documentVersioningService;
